import { Injectable, OnDestroy } from '@angular/core';
import { JwtService } from '../jwt/jwt.service';
import {
  BehaviorSubject,
  catchError,
  finalize,
  map,
  Observable,
  Subscription,
  throwError,
} from 'rxjs';
import { UserProfile } from '../../interfaces/user-profile';
import { AuthHttpService } from '../auth-http/auth-http.service';
import { Router } from '@angular/router';
import { CommonResponse } from '../../interfaces/common-response';
import { RefreshTokenRequest } from '../../interfaces/users/refresh-token-request';
import { User } from '../../interfaces/users/user';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';

export type UserType = UserProfile | undefined;
@Injectable({
  providedIn: 'root',
})
export class AuthService implements OnDestroy {
  private unsubscribe: Subscription[] = [];

  // public fields
  currentUser$: Observable<User>;
  isLoading$: Observable<boolean>;
  currentUserSubject: BehaviorSubject<User>;
  isLoadingSubject: BehaviorSubject<boolean>;

  baseUrlV2 = environment.baseUrlV2;

  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  set currentUserValue(user: User) {
    this.currentUserSubject.next(user);
  }

  constructor(
    private jwtService: JwtService,
    private authHttp: AuthHttpService,
    private router: Router,
    private http: HttpClient
  ) {
    this.isLoadingSubject = new BehaviorSubject<boolean>(false);
    this.currentUserSubject = new BehaviorSubject<User>(undefined);

    this.currentUser$ = this.currentUserSubject.asObservable();
    this.isLoading$ = this.isLoadingSubject.asObservable();
  }

  getUserDashboard(userId: number): Observable<any> {
    const url = `${environment.baseUrlV2}dashboards/GetUserDashboardNumbers/${userId}`;
    return this.http.get(url);
  }

  login(email: string, password: string): Observable<CommonResponse> {
    this.isLoadingSubject.next(true);

    return this.authHttp.login(email, password).pipe(
      map((res: CommonResponse) => {
        console.log(res);
        this.jwtService.saveTokenData(
          res.responseData.token,
          res.responseData.refreshToken
        );
        const user = this.jwtService.getProfile()!;
        this.currentUserSubject.next(user);
        console.log('user', this.currentUserValue);
        return res;
      }),
      catchError((error) => {
        // Optionally, log the error here if needed
        console.error('Error during login:', error);
        // Rethrow the error so the component can handle it
        return throwError(() => error);
      }),
      finalize(() => {
        this.isLoadingSubject.next(false);
      })
    );
  }

  logout() {
    this.jwtService.removeAuth();
    this.currentUserSubject.next(undefined);
    this.router.navigate(['/auth/login']);
  }

  refreshToken(): Observable<any> {
    let refreshTokenRequest: RefreshTokenRequest = {
      refreshToken: this.jwtService.getRefreshToken()!,
      token: this.jwtService.getToken()!,
    };
    return this.authHttp.refreshToken(refreshTokenRequest!).pipe(
      map((res: CommonResponse) => {
        console.log('refreshToken', res);
        this.jwtService.saveTokenData(
          res.responseData.token,
          res.responseData.refreshToken
        );
        this.currentUserSubject.next(res.responseData.Profile);
        return res;
      }),
      finalize(() => {
        this.isLoadingSubject.next(false);
      })
    );
  }

  getUserFromToken(): User | null {
    return this.jwtService.getProfile();
  }

  setSessionStorageItem(key: string, data: any) {
    sessionStorage.setItem(key, JSON.stringify(data));
  }

  ngOnDestroy(): void {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }
}
